import type {
  BatchProcessSummaryResponse,
  BatchProcessSummaryViewModel,
} from "@models/monitoring";

/**
 * Build batch process summary view model from response
 */
export const buildBatchProcessSummaryViewModel = (
  response: BatchProcessSummaryResponse,
): BatchProcessSummaryViewModel => {
  return {
    id: response.id,
    status: response.status,
    noProcessItems: response.no_process_items,
    createdAt: new Date(response.created_at),
  };
};
